const pageNameKey = "otaBackupProcessPendingApprovalByOperator";

export const otaBackupProcessPendingApprovalByOperatorEn = {
  [pageNameKey]: {
    title: "Backup Process Pending Approval by Operator",
    description:
      "Wait until the Operator accepts the backup process, then the backup will be finally created.",
    cancelRequestButtonText: "Cancel Request",
    cancelSuccessMessage: "Backup process request canceled successfully",
    cancelFailureMessage: "Failed to cancel backup process request",
  },
};

export const otaBackupProcessPendingApprovalByOperatorPtBr = {
  [pageNameKey]: {
    title: "Processo de backup com aprovação pendente pelo Operador",
    description:
      "Aguarde até que o Operador aceite o processo de backup, então o backup será finalmente criado.",
    cancelRequestButtonText: "Cancelar solicitação",
    cancelSuccessMessage:
      "Solicitação do processo de backup cancelada com sucesso",
    cancelFailureMessage:
      "Falha ao cancelar a solicitação do processo de backup",
  },
};

export const otaBackupProcessPendingApprovalByOperatorDe = {
  [pageNameKey]: {
    title: "Backup-Prozess wartet auf Genehmigung durch den Operator",
    description:
      "Warten Sie, bis der Operator den Backup-Prozess akzeptiert, dann wird das Backup endgültig erstellt.",
    cancelRequestButtonText: "Anfrage abbrechen",
    cancelSuccessMessage: "Backup-Prozessanfrage erfolgreich abgebrochen",
    cancelFailureMessage:
      "Backup-Prozessanfrage konnte nicht abgebrochen werden",
  },
};

export const otaBackupProcessPendingApprovalByOperatorZhHans = {
  [pageNameKey]: {
    title: "备份流程等待操作员批准",
    description: "请等待操作员接受备份流程，随后将最终创建备份。",
    cancelRequestButtonText: "取消请求",
    cancelSuccessMessage: "备份流程请求已成功取消",
    cancelFailureMessage: "取消备份流程请求失败",
  },
};

export const otaBackupProcessPendingApprovalByOperatorIt = {
  [pageNameKey]: {
    title:
      "Processo di backup in attesa di approvazione da parte dell'Operatore",
    description:
      "Attendi che l'Operatore accetti il processo di backup, quindi il backup verrà finalmente creato.",
    cancelRequestButtonText: "Annulla richiesta",
    cancelSuccessMessage:
      "Richiesta del processo di backup annullata con successo",
    cancelFailureMessage:
      "Impossibile annullare la richiesta del processo di backup",
  },
};

export const otaBackupProcessPendingApprovalByOperatorEs = {
  [pageNameKey]: {
    title: "Proceso de respaldo con aprobación pendiente por el Operador",
    description:
      "Espere hasta que el Operador acepte el proceso de respaldo; luego, el respaldo se creará finalmente.",
    cancelRequestButtonText: "Cancelar solicitud",
    cancelSuccessMessage:
      "Solicitud del proceso de respaldo cancelada correctamente",
    cancelFailureMessage:
      "No se pudo cancelar la solicitud del proceso de respaldo",
  },
};

export const otaBackupProcessPendingApprovalByOperatorNl = {
  [pageNameKey]: {
    title: "Back-upproces wacht op goedkeuring door operator",
    description:
      "Wacht tot de operator het back-upproces accepteert, daarna wordt de back-up definitief aangemaakt.",
    cancelRequestButtonText: "Verzoek annuleren",
    cancelSuccessMessage: "Back-upprocesverzoek succesvol geannuleerd",
    cancelFailureMessage: "Back-upprocesverzoek kon niet worden geannuleerd",
  },
};

export const otaBackupProcessPendingApprovalByOperatorTr = {
  [pageNameKey]: {
    title: "Yedekleme İşlemi Operatör Tarafından Onay Bekleniyor",
    description:
      "Operatör yedekleme işlemini kabul edene kadar bekleyin, ardından yedekleme en sonunda oluşturulacaktır.",
    cancelRequestButtonText: "İsteği İptal Et",
    cancelSuccessMessage: "Yedekleme işlemi isteği başarıyla iptal edildi",
    cancelFailureMessage: "Yedekleme işlemi isteği iptal edilemedi",
  },
};
